import React from 'react';
import i18n from 'i18next';

import * as S from '../styled';

type Props = {
  name: string,
}

const EmptyList = ({ name }: Props) => (
  <S.EmptyList>
    {i18n.t('dashboard.table.empty', { name })}
  </S.EmptyList>
);

export default EmptyList;
